import { FallbackProvidedSkeleton } from "@/components/Loading/FallbackProvidedSkeleton"
import { FallbackSpinner } from "@/components/Loading/FallbackSpinner"

export const Loading = {
	FallbackProvidedSkeleton,
	FallbackSpinner
}